import type { IconName } from "./Icon";

export type Tab = "readme" | "links" | "browser" | "monitor" | "runs" | "files";

type TabDef = {
  key: Tab;
  label: string;
  icon: IconName;
};

const TAB_DEFS: ReadonlyArray<TabDef> = [
  { key: "readme", label: "Readme", icon: "notebook-text" },
  { key: "monitor", label: "Monitor", icon: "scan-heart" },
  { key: "runs", label: "Runs", icon: "solo-run" },
  { key: "links", label: "Links", icon: "product-cases" },
  { key: "browser", label: "Browser", icon: "compass" },
  { key: "files", label: "Files", icon: "folder" },
];

export const VALID_TABS: ReadonlySet<string> = new Set(
  TAB_DEFS.map((t) => t.key)
);

export function resolveWorkflowTabOrder(
  saved: string | null | undefined
): ReadonlyArray<TabDef> {
  const byKey = new Map(TAB_DEFS.map((t) => [t.key, t]));
  const result: TabDef[] = [];
  if (saved) {
    for (const raw of saved.split(",")) {
      const key = raw.trim();
      const def = byKey.get(key as Tab);
      if (def) {
        result.push(def);
        byKey.delete(def.key);
      }
    }
  }
  for (const def of TAB_DEFS) {
    if (byKey.has(def.key)) result.push(def);
  }
  return result;
}
